document.addEventListener('DOMContentLoaded', function() {
    function initSizeGuideLink() {
      const trigger = document.querySelector('a.size-guide-link');
      const target = document.querySelector('#Avada-SC-button div');
      
      if (trigger && target) {
        target.style.display = 'none';
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          target.click();
        });
      }
    }

    initSizeGuideLink();

    let attempts = 0;
    const maxAttempts = 20; 
    
    const checkInterval = setInterval(() => {
      const target = document.querySelector('#Avada-SC-button div');
      if (target) {
        clearInterval(checkInterval);
        initSizeGuideLink();
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, 500);
  });